'use client';

import { useEffect, useState } from 'react';

const debounce = (func: (...args: any) => void, delay: number) => {
  let timer: NodeJS.Timeout;
  return (...args: any) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func(...args);
    }, delay);
  };
};

export const useBreakpoint = (breakpoint?: number) => {
  const [isSmaller, setIsSmaller] = useState(false);

  useEffect(() => {
    const handleResize = debounce(() => {
      setIsSmaller(window.innerWidth <= (breakpoint ?? 375));
    }, 500);

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return isSmaller;
};
